import ReactGTM from "react-gtm-module";

import { isDefined } from "@eroad/helpers/isDefined";
import { isDevelopmentEnv } from "@eroad/helpers/isDevelopmentEnv";
import { isTestRunEnv } from "@eroad/helpers/isTestRunEnv";

import { captureException } from "../sentry/sentry";

/**
 * Initialise Google Tag Manager.
 * This function should be called once at the start of the application.
 */
function initGTM(): void {
  if (!isGTMEnabled()) {
    return;
  }

  try {
    // Non-null assertion operator safe to use as the check is done in isGTMEnabled
    ReactGTM.initialize({ gtmId: process.env.REACT_APP_GTM_ID! });
  } catch (error) {
    if (error instanceof Error) {
      captureException(error, {
        tags: {
          manuallyReported: "true",
        },
      });
    }
  }
}

/**
 * @internal
 */
function isGTMEnabled(): boolean {
  const gtmId = process.env.REACT_APP_GTM_ID;

  return isDefined(gtmId) && !isDevelopmentEnv() && !isTestRunEnv();
}

export { initGTM };
